import FileSaver from 'file-saver'

function getSearchParameters() {
    var prmstr = window.location.search.substr(1);
    return prmstr != null && prmstr != "" ? transformToAssocArray(prmstr) : {};
}

function transformToAssocArray( prmstr ) {
    var params = {};
    var prmarr = prmstr.split("&");
    for ( var i = 0; i < prmarr.length; i++) {
        var tmparr = prmarr[i].split("=");
        params[tmparr[0]] = tmparr[1];
    }
    return params;
}

function transformErrorsToHtml (errors) {
    var html = '';

    if(Object.keys(errors).length > 0){
        html += '<ul>';
        for (var key in errors){
            var error_items = errors[key];
            for (var j = 0; j < error_items.length; j++){
                html += '<li>'+error_items[j]+'</li>';
            }
        }
        html += '</ul>';
    }

    return html;
}

const GlobalPlugin = {

    install(Vue, options) {

        Vue.transformErrorsToHtml = (errors) => {
            return transformErrorsToHtml(errors);
        }
        Vue.checkParams = () => {
            var queryExpense = getSearchParameters().expense;
            if ( queryExpense === 'realized') {
                Vue.swal({
                    type: 'success',
                    title: 'Płatność została zrealizowana.',
                    showConfirmButton: true,
                })
            } else if (queryExpense === 'already_realized') {
                Vue.swal({
                    type: 'success',
                    title: 'Przelew został zrealizowany już wcześniej.',
                    showConfirmButton: true,
                })
            }
        };

        Vue.googleDirections = (to) => {
            let link = 'https://www.google.com/maps/dir/?api=1&destination=' + to;
            window.open(encodeURI(link));
        };

        Vue.mergeLists = (list1, list2, name) => {
            const result = [...list1.concat(list2)
                .reduce((r, o) => {
                    r.has(o[name]) || r.set(o[name], {});

                    const item = r.get(o[name]);

                    Object.entries(o).forEach(([k, v]) =>
                        item[k] = Array.isArray(item[k]) ?
                            [...new Set([...item[k], ...v])] : v
                    );

                    return r;
                }, new Map()).values()];

            return result;
        };

        Vue.downloadFile = (address, params, name) => {
            axios.post(
                address,
                params,
                {
                    headers: {"Authorization": 'Bearer ' + window.localStorage.getItem('token')},
                    responseType: 'blob'
                }).then(response => {
                let blob = new File([response.data], name, { type: response.headers['content-type'] } );
                FileSaver.saveAs(blob);
            }).catch((error)=>{
                Vue.swal({
                    title: 'Nie udało się pobrać pliku',
                    text: 'Wystąpił błąd podczas pobierania. Spróbuj ponownie za jakiś czas.',
                    type: 'error',
                });
            });
        };

        Vue.appendFormdata = (FormData, data, name) => {
            name = name || '';

            if (
                typeof data === 'object' && data !== null &&
                !name.includes('[file]') && name !== 'file' &&
                !name.includes('[scan_1]') && name !== 'scan_1' &&
                !name.includes('[scan_2]') && name !== 'scan_2'
                && !name.includes('files[')
            ){
                for (let item in data) {
                    if (name == ''){
                        Vue.appendFormdata(FormData, data[item], item);
                    } else {
                        Vue.appendFormdata(FormData, data[item], name + '['+item+']');
                    }
                }
            } else {
                if (data === null || data === NaN || data === 'NaN'){
                    FormData.append(name, '');
                }
                else {
                    FormData.append(name, data);
                }
            }
        };

        Vue.appendFormdataFiles = (FormData, data, name) => {
            name = name || '';

            if (
                typeof data === 'object' && data !== null &&
                !name.includes('[file]') && name !== 'file' &&
                !name.includes('[scan_1]') && name !== 'scan_1' &&
                !name.includes('[scan_2]') && name !== 'scan_2'
            ){
                for (let item in data) {
                    if (name == ''){
                        Vue.appendFormdataFiles(FormData, data[item], item);
                    } else {
                        Vue.appendFormdataFiles(FormData, data[item], name + '['+item+']');
                    }
                }
            } else {
                if (data === null || data === NaN || data === 'NaN'){
                    FormData.append(name, '');
                }
                else {
                    FormData.append(name, data);
                }
            }
        };

        Vue.getHours = function() {
            let hours = 24;
            let minutes = 60;
            let minutes_gap = 30;
            let time_options = [];
            for ( let h = 0; h < hours; h++) {
                for ( let min = 0; min < minutes; min = min + minutes_gap) {
                    let option = (h < 10 ? '0' + h : h) + ':' + (min < 10? '0' + min : min);
                    time_options.push(option);
                }
            }
            time_options.push('24:00');
            return time_options;
        };
        Vue.getCurrentDate = function() {
            let d = new Date();
            let dy = d.getFullYear();
            let dm = (d.getMonth()+1) < 10 ? '0' + (d.getMonth()+1) : (d.getMonth()+1);
            let dd = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();

            return dy + '-' + dm + '-' + dd;
        };

        Vue.getDayName = function(n) {
            let days = ['Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota', 'Niedziela'];
            n = n - 1;
            return days[n];
        };
        Vue.toNumber = function(n) {
            return Vue.numberFormat(n, 2, ',', ' ');
        };
        Vue.numberFormat = function(number, decimals, dec_point, thousands_sep){
            number = (number + '').replace(',', '').replace(' ', '');
            var n = !isFinite(+number) ? 0 : +number,
                prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
                sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
                dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
                s = '',
                toFixedFix = function (n, prec) {
                    var k = Math.pow(10, prec);
                    return '' + Math.round(n * k) / k;
                };
            // Fix for IE parseFloat(0.55).toFixed(0) = 0;
            s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
            if (s[0].length > 3) {
                s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
            }
            if ((s[1] || '').length < prec) {
                s[1] = s[1] || '';
                s[1] += new Array(prec - s[1].length + 1).join('0');
            }
            return s.join(dec);
        };
    }
};

export default GlobalPlugin;
